import { CustomFieldCheckboxForm } from 'components/custom-fields/CustomFieldCheckboxForm';
import { CustomFieldDateForm } from 'components/custom-fields/CustomFieldDateForm';
import { CustomFieldNumberForm } from 'components/custom-fields/CustomFieldNumberForm';
import { CustomFieldOptionForm } from 'components/custom-fields/CustomFieldOptionForm';
import { CustomFieldTextForm } from 'components/custom-fields/CustomFieldTextForm';
import { toFriendlyType } from 'components/custom-fields/helpers';
import * as Form from 'components/form';

const CustomFieldComponentByType = () => {
    const { getValues } = Form.useGivebutterFormContext();
    const type = toFriendlyType(getValues('type'));

    switch (type) {
        case 'checkbox':
            return <CustomFieldCheckboxForm />;
        case 'date':
            return <CustomFieldDateForm />;
        case 'option':
            return <CustomFieldOptionForm />;
        case 'number':
            return <CustomFieldNumberForm />;
        case 'text':
        default:
            return <CustomFieldTextForm />;
    }
};

const Type = CustomFieldComponentByType;

export { CustomFieldComponentByType, Type };
